import { BaseLiveConnection } from '@pascal/pascal-core';

import { API } from '../../../core/constants/endpoints';
import { gameService } from '../gameService';
import { GameLiveConnectionMethod } from '../../../enums/GameLiveConnectionMethod';
import { gameStore } from '../../store/gameStore';
import { configStore } from '../../store/configStore';

export class RealGameLiveConnection extends BaseLiveConnection{
  constructor() {
    super(`${API}/game`);
  }

  setConnectionListeners() {
    this.connection.on(GameLiveConnectionMethod.GetInitialStateResult, gameService.onGetInitialStateResult);
    this.connection.on(GameLiveConnectionMethod.CashOutResult, gameService.onCashOutResult);
    this.connection.on(GameLiveConnectionMethod.ResultReportResult, gameService.onResultReportResult);
    this.connection.on(GameLiveConnectionMethod.DoSpinResult, gameService.onDoSpinResult);
    this.connection.on(GameLiveConnectionMethod.GameOpen, (arg) => gameService.onGameOpen(arg, this.connection));
    super.onReconnecting(gameService.handleReconnecting.bind(gameService))
    super.onReconnected(gameService.handleReconnected.bind(gameService))
  }

  sendGetInitialState() {
    return this.invoke(GameLiveConnectionMethod.GetInitialState, { partnerId: configStore.partnerId });
  }

  sendDoSpin() {
    return this.invoke(GameLiveConnectionMethod.DoSpin,gameStore.amount, gameStore.matrixType);
  }

  sendResultReport() {
    return this.invoke(GameLiveConnectionMethod.ReportState, gameStore.chosenField);
  }

  sendCashOut() {
    return this.invoke(GameLiveConnectionMethod.CashOut);
  }
}